import { getDateWithYear, untilDate } from '../shared/date';
import { toFixedNumber } from '../shared/helpers';
import * as plans from '../shared/subscription-plans';

const subscriptionNameMapping = {
    [plans.WEEKLY_WITHOUT_TRIAL_PLAN]: '1-week plan',
    [plans.WEEKLY_999_WITH_WEEK_750_TRIAL_PLAN]: '1-week plan',
    [plans.WEEKLY_999_WITHOUT_TRIAL_PLAN]: '1-week plan',
    [plans.WEEKLY_499_WITH_WEEK_375_TRIAL_PLAN]: '1-week plan',
    [plans.WEEKLY_499_WITH_WEEK_349_TRIAL_PLAN]: '1-week plan',
    [plans.WEEKLY_499_WITHOUT_TRIAL_PLAN]: '1-week plan',
    [plans.WEEKLY_WITH_WEEK_PAID_TRIAL_PLAN]: '1-week plan',
    [plans.MONTHLY_WITH_PAID_TRIAL_PLAN]: '7-day plan',
    [plans.MONTHLY_WITHOUT_TRIAL_PLAN]: '1-Month plan',
    [plans.MONTHLY_WITH_MONTH_PAID_TRIAL_PLAN]: '1-Month plan',
    [plans.MONTHLY_3999_WITH_MONTH_2999_TRIAL_PLAN]: '1-Month plan',
    [plans.MONTHLY_3999_WITH_1999_TRIAL_PLAN]: '1-Month plan',
    [plans.MONTHLY_3999_WITHOUT_TRIAL_PLAN]: '1-Month plan',
    [plans.MONTHLY_1999_WITH_MONTH_1499_TRIAL_PLAN]: '1-Month plan',
    [plans.MONTHLY_1999_WITH_MONTH_1399_TRIAL_PLAN]: '1-Month plan',
    [plans.MONTHLY_1999_WITHOUT_TRIAL_PLAN]: '1-Month plan',
    [plans.QUARTERLY_WITHOUT_TRIAL_PLAN]: '3-Month plan',
    [plans.QUARTERLY_WITH_QUARTER_PAID_TRIAL_PLAN]: '3-Month plan',
    [plans.QUARTERLY_7999_WITH_QUARTER_5999_TRIAL_PLAN]: '3-Month plan',
    [plans.QUARTERLY_7999_WITHOUT_TRIAL_PLAN]: '3-Month plan',
    [plans.QUARTERLY_3999_WITH_QUARTER_2999_TRIAL_PLAN]: '3-Month plan',
    [plans.QUARTERLY_3999_WITH_QUARTER_2799_TRIAL_PLAN]: '3-Month plan',
    [plans.QUARTERLY_3999_WITHOUT_TRIAL_PLAN]: '3-Month plan'
};

const currentSubscriptionMapper = {
    toDomain(subscriptionData) {
        return {
            price: `$${toFixedNumber(subscriptionData.price / 100)}`,
            name: subscriptionNameMapping[subscriptionData.plan],
            billingPeriod: subscriptionData.billingPeriod,
            plan: subscriptionData.plan,
            id: subscriptionData.id,
            status: subscriptionData.status,
            nextChargeDate: subscriptionData.nextChargeAt ? getDateWithYear(subscriptionData.nextChargeAt) : null,
            validUntilDate: getDateWithYear(subscriptionData.validUntil),
            isActive: untilDate(subscriptionData.validUntil).isValid,
            cancelIsFrozen: false
        }
    }
};

export {
    currentSubscriptionMapper,
    subscriptionNameMapping
};
